import { Controller } from "@hotwired/stimulus"

// Filtre une liste d'éléments (`item`, libellé dans data-label) par le texte d'un champ (`input`).
// Options : `count` (le nombre affiché), `list` (masquée si vide), `create` (le bouton qui envoie
// le texte tel quel : Entrée choisit l'élément en tête, lui non) ; `reset` vide la recherche
// (après un envoi). Les éléments arrivés après coup (liste chargée ou re-rendue par le serveur)
// suivent la recherche en cours.
export default class extends Controller {
  static targets = ["item", "input", "count", "list", "create"]
  // hideUntilSearch : la liste reste masquée tant que rien n'est tapé (ex. partage d'écran client)
  static values = { highlightFirst: String, hideUntilSearch: Boolean }

  get highlightClasses() {
    return this.highlightFirstValue?.split(" ").filter(Boolean) || []
  }

  filter() {
    const searchTerm = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.firstVisibleItem = null

    this.itemTargets.forEach(item => {
      const text = this.labelOf(item)
      const visible = searchTerm === "" ? !this.hideUntilSearchValue : text.includes(searchTerm)
      item.style.display = visible ? "" : "none"
      this.unhighlight(item)
      if (visible) {
        visibleCount++
        if (!this.firstVisibleItem) this.firstVisibleItem = item
      }
    })

    if (this.firstVisibleItem) this.highlight(this.firstVisibleItem)

    if (this.hasListTarget) this.listTarget.hidden = visibleCount === 0


    if (this.hasCountTarget) {
      const hiddenByDefault = searchTerm === "" && this.hideUntilSearchValue
      this.countTarget.textContent = hiddenByDefault ? this.itemTargets.length : visibleCount
    }
  }

  // « Tout voir » : lève le masquage hideUntilSearch, la recherche reste utilisable
  showAll(event) {
    this.hideUntilSearchValue = false
    event.currentTarget.hidden = true
    this.filter()
  }

  highlightOnHover(event) {
    this.itemTargets.forEach(item => this.unhighlight(item))
    this.highlight(event.currentTarget)
    this.firstVisibleItem = event.currentTarget
  }

  resetHighlight() {
    this.filter()
  }

  itemTargetConnected() {
    if (this.hasInputTarget && this.inputTarget.value) this.filter()
  }

  reset() {
    this.inputTarget.value = ""
    this.filter()
  }

  labelOf(item) {
    return (item.dataset.label || item.textContent).toLowerCase().trim()
  }

  // Entrée choisit l'élément en tête ; le bouton `create`, cliqué, envoie le texte tel quel.
  submit(event) {
    if (this.hasCreateTarget && event.submitter === this.createTarget) return
    if (this.firstVisibleItem) {
      event.preventDefault()
      this.firstVisibleItem.click()
    }
  }

  highlight(item) {
    if (this.highlightClasses.length) item.classList.add(...this.highlightClasses)
  }

  unhighlight(item) {
    if (this.highlightClasses.length) item.classList.remove(...this.highlightClasses)
  }
}
